import React from 'react'
import { observer } from 'mobx-react'

import PrimaryControls from './PrimaryControls'
import FilterControls from '../../../../infra/FilterControls'

import styles from './JobsViewerHeader.sass'
import { useToggle } from 'hooks/state-hooks'
import JobManagementViewModel from '../JobManagementViewModel'

interface JobsViewerHeaderProps {
  vm: JobManagementViewModel
}

export default observer(function JobsViewerHeader({
  vm,
}: JobsViewerHeaderProps) {
  const hasFilters = vm.searcher.filters.appliedFilterCount > 0
  const showingFilterControls = useToggle(hasFilters)

  return (
    <div className={styles.jobsViewerHeader}>
      <PrimaryControls
        vm={vm}
        onChange={vm.searcher.searchText.change}
        onShowFilterControlsClick={showingFilterControls.toggle}
        filterCount={vm.searcher.filters.appliedFilterCount}
        value={vm.searcher.searchText.value}
      />
      <FilterControls
        active={showingFilterControls.isEnabled}
        vm={vm.searcher.filters}
      />
    </div>
  )
})
